<template>
  <Dialog v-model="visible" :title="$t('monopoly.chooseStepsTitle')">
    <div class="choose-steps">
      <div class="steps">
        <div
          v-for="n in stepOptions"
          :key="n"
          class="step-item"
          :class="{ active: selected === n }"
          @click="selected = n"
        >
          <div class="check-box">
            <img
              v-if="selected === n"
              class="check-icon"
              src="@/views/act/monopoly/assets/img/dagou.png"
              alt="checked"
            >
          </div>
          <div class="label">
            {{ $t('monopoly.chooseStepsOption', { steps: n }) }}
          </div>
        </div>
      </div>
      <Btn type="blue" class="confirm-btn" @click="handleConfirm">
        {{ $t('monopoly.chooseStepsConfirm') }}
      </Btn>
    </div>
  </Dialog>
</template>

<script setup>
import { computed, ref, watch, defineProps, defineEmits } from 'vue'
import Dialog from '../Dialog/index.vue'
import Btn from '../Btn/index.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

// 两列：左 1/3/5，右 2/4/6
const stepOptions = [1, 2, 3, 4, 5, 6]
const selected = ref(1)

watch(
  () => props.modelValue,
  (val) => {
    if (val) selected.value = 1
  }
)

const handleConfirm = () => {
  emit('confirm', selected.value)
  visible.value = false
}
</script>

<style lang="less" scoped>
.choose-steps {
  width: 100%;
  color: #1a3a6e;
}

.steps {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 40px;
  row-gap: 28px;
  width: 100%;
  max-width: 560px;
  margin: 10px auto 40px;
  padding: 0 20px;
  box-sizing: border-box;
}

.step-item {
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  user-select: none;

  .check-box {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    box-sizing: border-box;
    border: 2px solid #9bb4d4;
    border-radius: 6px;
    background: #eef3f8;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .check-icon {
    width: 34px;
    height: auto;
  }

  .label {
    font-size: 30px;
    font-weight: 600;
    line-height: 1.2;
    color: #1a3a6e;
  }

  &.active {
    .check-box {
      border-color: #7ec8ff;
      background: #fff;
    }
  }
}

.confirm-btn {
  margin: 0 auto;
}
</style>
